import { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { label: "Home", id: "home" },
    { label: "Services", id: "services" },
    { label: "Portfolio", id: "portfolio" },
    { label: "Testimonials", id: "testimonials" },
    { label: "Contact", id: "contact" },
  ];

  const scrollToSection = (id) => {
    if (id === "home") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      const element = document.getElementById(id);
      if (element) {
        const yOffset = -80;
        const y =
          element.getBoundingClientRect().top +
          window.pageYOffset +
          yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  };

  const handleScroll = (id) => {
    if (location.pathname !== "/") {
      navigate("/");

      setTimeout(() => {
        scrollToSection(id);
      }, 300); // important delay
    } else {
      scrollToSection(id);
    }

    setIsOpen(false);
  };

  return (
    <motion.nav
      className="fixed top-0 w-full z-50 backdrop-blur-md bg-black/20 border-b border-white/10"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">

        {/* Logo */}
        <div onClick={() => handleScroll("home")} className="cursor-pointer">
          <img src="../../assets/logo.png" alt="Logo" className="h-12" />
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-8">
          {menuItems.map((item) => (
            <button
              key={item.label}
              onClick={() => handleScroll(item.id)}
              className="text-white/80 hover:text-orange-400 text-sm font-medium"
            >
              {item.label}
            </button>
          ))}

          {/* Get Started Button */}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() =>
              window.open("https://wa.me/923337111075", "_blank")
            }
            className="px-6 py-2 bg-gradient-to-r from-orange-400 to-orange-600 text-black font-semibold rounded-lg hover:shadow-lg hover:shadow-orange-500/50 transition-all"
          >
            Get Started
          </motion.button>
        </div>

        {/* Mobile Toggle */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="md:hidden text-white text-2xl"
        >
          ☰
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-black/80 px-6 py-4 flex flex-col gap-4">
          {menuItems.map((item) => (
            <button
              key={item.label}
              onClick={() => handleScroll(item.id)}
              className="text-white/80 hover:text-orange-400 text-left"
            >
              {item.label}
            </button>
          ))}

          <button
            onClick={() =>
              window.open("https://wa.me/923337111075", "_blank")
            }
            className="mt-4 px-6 py-2 bg-orange-500 text-black rounded-lg font-semibold"
          >
            Get Started
          </button>
        </div>
      )}
    </motion.nav>
  );
}